import React, { ReactElement } from 'react';
import classNames from 'classnames/bind';
import styles from 'sections/Home/components/SectionSeoInfo/SectionSeoInfo.module.scss';

const cn = classNames.bind(styles);

const SectionSeoInfo = (): ReactElement => {
  return (
    <section className={cn('seo-info')}>
      <div className={cn('container')}>
        <p className={cn('seo-info__paragraph')}>
          Digital Freight Alliance is a network of freight forwarders, spearheaded by industry giant DP World. With a
          global presence spanning 190 countries, DF ALLIANCE swiftly rose to prominence, boasting a membership
          exceeding 8,000 freight forwarders worldwide.
        </p>
        <p className={cn('seo-info__paragraph')}>
          DF Alliance is not merely a platform; it's a transformative force in the realm of freight forwarding
          networks. At its core, DF Alliance serves as a digital hub where freight forwarders converge to unlock a
          world of possibilities. Upon membership, forwarders gain access to a suite of cutting-edge tools tailored to
          streamline their operations and bolster efficiency.
        </p>
        <p className={cn('seo-info__paragraph')}>
          At the heart of DF Alliance lies its commitment to empowering international freight forwarders. In a
          landscape defined by rapid globalization, DF Alliance equips forwarders with the tools they need to thrive
          on the global stage. Through our comprehensive network, forwarders seamlessly connect with partners
          worldwide, forging alliances that transcend borders and drive mutual success.
        </p>
        <p className={cn('seo-info__paragraph')}>
          What sets DF Alliance apart is its unwavering dedication to innovation. As a forward-thinking platform, DF
          Alliance continually evolves to meet the evolving needs of the industry. From pioneering digital solutions
          to embracing emerging technologies, DF Alliance remains at the forefront of the freight forwarding
          revolution.
        </p>
        <p className={cn('seo-info__paragraph')}>
          In the fast-paced world of global forwarding, success hinges on collaboration and connectivity. DF Alliance
          serves as the bridge that unites forwarders, fostering a community built on trust, reliability, and mutual
          growth. Together, we navigate the complexities of international trade, propelling businesses to new heights
          of success.
        </p>
      </div>
    </section>
  );
};

export default SectionSeoInfo;